<template>
	<swiper
		:pagination="pagination"
		:navigation="navigation"
		:slides-per-view="1"
	>
		<!-- slide slot -->
		<slot name="swiperSlide"></slot>
	</swiper>
</template>

<script>
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper } from 'swiper/vue';

SwiperCore.use([Navigation, Pagination]);

export default {
	name: 'Swipe',
	props: {
		navigation: {
			type: Boolean,
			default: false,
		},
		pagination: {
			type: Object,
		},
	},
	components: {
		Swiper,
	},
};
</script>

<style lang="scss"></style>
